class StDateTimePickerController {
    constructor(DATE_FORMAT) {
        'ngInject';
        this.name = 'stDateTimePicker';
        this.date = typeof this.date === 'object' ? this.date: this.createDate(this.date);
        this.oldDate = this.date;
        this.DATE_FORMAT = DATE_FORMAT;
        this.datePickerOptions = {
            formatYear: 'yyyy',
            showWeeks: false,
            initDate: this.date,
            minDate: new Date()
        };
        this.timePickerOptions = {
            isMeridian: false,
            minDate: new Date()
        };

        if (this.maxDate) {
            this.datePickerOptions.maxDate = this.maxDate;
        }

        this.dropdownStatus = {
            isopen: false
        };

        if (this.minDate) {
            let minDateObj = typeof this.minDate === 'object' ? this.minDate: this.createDate(this.minDate);
            let newMinDate = new Date();
            newMinDate.setDate(minDateObj.getDate() - 1); // Subtract 1 day (24h)

            if (newMinDate > (new Date())) {
                this.minDate = newMinDate;
                this.datePickerOptions.minDate = this.minDate;
                this.timePickerOptions.minDate = this.minDate;
            }
        }
    }

    $onInit() {
    }

    save($event) {
        $event.preventDefault();
        $event.stopPropagation();
        this.dropdownStatus.isopen = false;
        this.oldDate = this.date;
    };

    createDate(dateTimeString) {
        let dateTime = dateTimeString.split(' ');
        let date = dateTime[0].split('-');
        let time = dateTime[1].split(':');
        let dateObject = new Date();

        dateObject.setFullYear(Number(date[0]), Number(date[1])-1, Number(date[2]));
        dateObject.setHours(Number(time[0]),Number(time[1]), 0);

        return dateObject;
    }

    toggleDropdown() {
        this.dropdownStatus.isopen = !this.dropdownStatus.isopen;
    };

    closeDropDown() {
        this.dropdownStatus.isopen = false;
        this.date = this.oldDate;
    }

    toggleModeMeridian() {
        this.timePickerOptions.isMeridian = !this.timePickerOptions.isMeridian;
    }
}

export default StDateTimePickerController;


// WEBPACK FOOTER //
// ./client/app/common/stDateTimePicker/stDateTimePicker.controller.js